const Menu = [
  { path: '/home', icon: 'fa fa-sitemap', title: 'Home' },

  {
    path: '#', icon: 'fa fa-align-left', title: 'Shipment',
    children: [
      { path: '/shipment', icon: '', title: 'Shipment', }, 
      { path: '/shipment/bulky-upload', icon: '', title: 'Bulky Upload', }
    ]
  },
  {
    path: '#', icon: 'fa fa-align-left', title: 'Integration Log',
    children: [
      { path: '/integration-log/outbound', title: 'Outbound API' },
      { path: '/integration-log/inbound', title: 'Inbound API' },
      { path: '/integration/background-job', title: 'Background Job' },
    ]
  },
  {
    path: '#', icon: 'fa fa-align-left', title: 'Configuration',
    children: [
      {
        path: '#', title: 'Account',
        children: [
          { path: '/account', title: 'Account' },
        ]
      },
      {
        path: '#', title: 'Region / Area',
        children: [
          { path: '/area/province', title: 'Province' },
          { path: '/area/city', title: 'City' },
          { path: '/area/district', title: 'District' },
          { path: '/area/subdistrict', title: 'Sub District' },
        ]
      },
      {
        path: '#', title: 'Couriers',
        children: [
          { path: '/courier', title: 'Courier Master' },
          { path: '/courier/area', title: 'Courier Area' },
          { path: '/courier/service-type', title: 'Courier Service Type' },
          { path: '/courier/status', title: 'Courier Status' },
        ]
      },
      {
        path: '#', icon: 'fa fa-users', title: 'User',
        children: [
          { path: '/user', title: 'User List' },
          { path: '/api-client', title: 'Api Client' },
        ]
      },
      {
        path: '#', title: 'Master Data',
        children: [
          { path: '/master-data/service-type', title: 'Service Type' },
          { path: '/master-data/status', title: 'Status' },
          { path: '/master-data/package-type', title: 'Package Type' },

          // { path: '/courier/area', title: 'Courier Area' },
        ]
      },
    ]
  },
  /*
  { path: '/menu', icon: 'fa fa-align-left', title: 'Menu Level',
    children: [
      { path: '/menu/menu-1-1', title: 'Menu 1.1',
        children: [
          { path: '/menu/menu-1-1/menu-2-1', title: 'Menu 2.1',
            children: [
              { path: '/menu/menu-1-1/menu-2-1/menu-3-1', title: 'Menu 3.1' },
              { path: '/menu/menu-1-1/menu-2-1/menu-3-2', title: 'Menu 3.2' }
            ]
          },
          { path: '/menu/menu-1-1/menu-2-2', title: 'Menu 2.2' },
          { path: '/menu/menu-1-1/menu-2-3', title: 'Menu 2.3' },
        ]
      },
      { path: '/menu/menu-1-2', title: 'Menu 1.2' },
      { path: '/menu/menu-1-3', title: 'Menu 1.3' },
    ]
  }
  */
]

export default Menu;